import ReportedUsersTable from './ReportedUsersTable';

export default ReportedUsersTable;
